<template>
  <LoaderMonitor>
    <template #default="{ sessionState, sessionId }">
      <BulkTaskJobPackageEditor
        :sessionState="sessionState"
        :sessionId="sessionId"
        v-bind="$attrs"
      />
    </template>
  </LoaderMonitor>
</template>

<script>
import LoaderMonitor from '../LoaderMonitor.vue';
import BulkTaskJobPackageEditor from '../BulkTaskJobPackageEditor.vue';

export default {
  name: 'BulkTaskJobPackageEditorWrapper',
  components: {
    LoaderMonitor,
    BulkTaskJobPackageEditor
  }
};
</script>